import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { hero } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function Hero() {
  return <section id="top" aria-labelledby="hero-heading" className="w-full scroll-mt-16 bg-forest-dark px-5 pb-10 pt-5 text-ivory md:px-8 md:pb-14 md:pt-10 lg:pb-16 lg:pt-12" data-id="element-106" data-mp="9k0bkz0gjzlf">
      <div className="mx-auto grid w-full max-w-content items-center gap-5 lg:grid-cols-[1fr_1.05fr] lg:gap-14" data-id="element-107" data-mp="129qvjoortvpg">
        <div className="text-center lg:text-left" data-id="element-108" data-mp="xbpc32nfnudg">
          <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-sage md:text-[13px]" data-id="element-109" data-mp="sbb0xbqjc4b7">
            {hero.eyebrow}
          </p>
          <h1 id="hero-heading" className="mx-auto mt-2.5 max-w-3xl font-serif text-[clamp(2.25rem,5.2vw,4rem)] font-medium leading-[1.02] md:mt-4 lg:mx-0" data-id="element-110" data-mp="nbexbdlr2ew6">
            {hero.title}
          </h1>
          <p className="mx-auto mt-3 max-w-xl text-base leading-normal text-ivory/80 md:mt-5 md:text-lg md:leading-relaxed lg:mx-0" data-id="element-111" data-mp="384jud2bfbpui">
            {hero.subheading}
          </p>

          <p className="mt-7 hidden items-center gap-4 font-serif text-2xl font-semibold leading-snug text-ivory lg:flex" data-id="element-112" data-mp="3o73no75q7m5y">
            <span aria-hidden="true" className="h-px w-10 shrink-0 bg-brass" data-id="element-113" data-mp="39cfofaqx5jys" />
            {hero.productLine}
          </p>

          <div className="mt-8 hidden w-full max-w-md lg:block" data-id="element-114" data-mp="30ib0az366mmy">
            <CtaButton tone="onDark" fullWidth data-id="element-115" data-mp="30fy87t3p6vw6" />
            <HeroSupport data-id="element-116" data-mp="358zqmb345dki" />
          </div>
        </div>

        <div className="rounded-xl bg-ivory px-3 pb-3 pt-3 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.6)] md:px-6 md:pb-6 md:pt-5" data-id="element-117" data-mp="35audhuxy3fr8">
          <p className="text-center font-serif text-base font-semibold leading-snug text-forest md:text-xl lg:hidden" data-id="element-118" data-mp="2viokqizvcuaz">
            {hero.productLine}
          </p>
          <img src={siteConfig.heroImage} alt={hero.imageAlt} width={1254} height={1254} loading="eager" decoding="async" className="mx-auto mt-1 aspect-square h-auto max-h-[190px] w-full object-contain sm:max-h-[300px] md:max-h-[380px] lg:mt-0 lg:max-h-[min(560px,calc(100vh-190px))]" data-id="element-119" data-mp="2hl9s75ebk6es" />
        </div>

        <div className="mx-auto w-full max-w-md lg:hidden" data-id="element-120" data-mp="ici1dbpliu7r">
          <CtaButton tone="onDark" fullWidth data-id="element-121" data-mp="de6oes4083lb" />
          <HeroSupport data-id="element-122" data-mp="db2fjhflgjob" />
        </div>
      </div>
    </section>;
}
function HeroSupport() {
  return <div className="mt-3 flex flex-col items-center gap-1 text-center lg:items-start lg:text-left" data-id="element-123" data-mp="1ayjgnc33rc57">
      <p className="text-[15px] text-ivory/75" data-id="element-124" data-mp="15zzw9g45q8ey">{hero.microcopy}</p>
      <a href="#collection" className="inline-flex min-h-11 items-center gap-2 text-[15px] font-semibold text-ivory underline decoration-brass decoration-1 underline-offset-[6px] transition-colors duration-150 ease-out hover:decoration-ivory" data-id="element-125" data-mp="11152jj4nizg2">
        {hero.secondaryLink}
        <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="3hpsen5c8br21" />
      </a>
    </div>;
}